export default __webpack_public_path__ + "static/media/archive-content 1.d9209015.svg";